import { getChannelAPIPath } from '@treasury/core/http';

AchSettingsService.$inject = ['$resource', '$q', '$http'];

export default function AchSettingsService($resource, $q, $http) {
    return {
        get,
    };

    function get() {
        return $resource(`${getChannelAPIPath()}achSettings`).get().$promise;
    }
}
